<template>
  <div id="CloudList">
    <SolutionsList
      :list="list"
      :view-loader="viewLoader"
      :view-error="viewError"
      :no-data-message="$t('cloud.noData')"
      :colspan="7"
      :page-size="pageSize"
    >
      <template #table-headers>
        <th v-if="!$IsMobile()">{{ $t("cloud.assetType") }}</th>
        <th>{{ $t("cloud.solution") }}</th>
        <th class="alignCenter">{{ $t("cloud.tbyte") }}</th>
        <th class="alignCenter">RAM (MB)</th>
        <th class="alignCenter">vCPU</th>
        <th v-if="!$IsMobile()"></th>
        <th v-if="!$IsMobile()"></th>
      </template>
      <template #mobile-row="{ item }">
        <MobileCard
          :titles="['solution_type', 'solution']"
          :item="item"
          translation-path="ticketsList.Cloud"
        >
        </MobileCard>
      </template>
      <template #desktop-row="{ item }">
        <tr>
          <td>
            <span>{{
              $t("cloud.types." + item.solution_type)
            }}</span>
          </td>
          <td>
            <span>{{ item.solution }}</span>
          </td>
          <td class="alignCenter">
            <span>{{ item.size }}</span>
          </td>
          <td class="alignCenter">
            <span>{{ item.ram }}</span>
          </td>
          <td class="alignCenter">
            <span>{{ item.vcpu }}</span>
          </td>
          <td>
            <HelpRequestBtn
              :component-name="'CloudIncidentForm'"
              :asset-type="'cloud'"
              :item-id="item.id"
              :icon="'warning'"
              :label="$t('help.incident.formTitle')"
              :skip-duplicate-warning="true"
            />
          </td>
          <td>
            <HelpRequestBtn
              :component-name="'CloudChangeRequestForm'"
              :asset-type="'cloud'"
              :item-id="item.id"
              :icon="'person'"
              :label="$t('help.changeRequest.formTitle')"
              :skip-duplicate-warning="true"
            />
          </td>
        </tr>
      </template>
    </SolutionsList>
  </div>
</template>

<style lang="scss">
td,
th {
  text-align: left;
  &.alignCenter {
    text-align: center;
  }
}
</style>

<script>
import SolutionsList from "@/components/Solutions/SolutionsList.vue";
import HelpRequestBtn from "@/components/Tables/HelpRequestBtn";
import MobileCard from "@/components/Cards/MobileCard.vue";

export default {
  name: "CloudList",
  components: {
    MobileCard,
    SolutionsList,
    HelpRequestBtn,
  },
  props: {
    list: Array,
    viewLoader: Boolean,
    viewError: Boolean,
    noItems: Boolean,
    pageSize: {
      type: Number,
      default: 10,
    },
  },
};
</script>
